import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

import { AuthContext } from "../../AuthContext";
import { apiGet } from "../../api";
import AppCallout from "../../design-system/components/AppCallout";
import AppWorkspace from "../../design-system/components/AppWorkspace";
import { getDefaultReportingRoute } from "./reportingFeatures";
import "./reporting.css";

export default function ReportingEntry() {
  const { logout } = useContext(AuthContext);
  const { t } = useTranslation();
  const [routeState, setRouteState] = useState({ loaded: false, route: null, failed: false });

  useEffect(() => {
    let active = true;

    const loadReportMode = async () => {
      try {
        const [features, punchClockFeature] = await Promise.all([
          apiGet("/api/web/feature-web", logout),
          apiGet("/api/web/feature-special/punch_clock", logout),
        ]);
        if (active) {
          setRouteState({
            loaded: true,
            route: getDefaultReportingRoute(features, punchClockFeature?.enabled),
            failed: false,
          });
        }
      } catch {
        if (active) {
          setRouteState({ loaded: true, route: null, failed: true });
        }
      }
    };

    loadReportMode();
    return () => {
      active = false;
    };
  }, [logout]);

  if (routeState.route) return <Navigate to={routeState.route} replace />;

  return (
    <div className="reporting-page">
      <AppWorkspace title={t("sidebar.report")} loading={!routeState.loaded}>
        {routeState.loaded ? (
          <AppCallout
            variant={routeState.failed ? "error" : "info"}
            title={t(routeState.failed ? "report.route_load_error_title" : "report.no_route_title")}
            description={t(
              routeState.failed
                ? "report.route_load_error_description"
                : "report.no_route_description"
            )}
          />
        ) : null}
      </AppWorkspace>
    </div>
  );
}
